import { render, staticRenderFns } from "./wx-register.vue?vue&type=template&id=5172950a&scoped=true&"
import script from "./wx-register.vue?vue&type=script&lang=js&"
export * from "./wx-register.vue?vue&type=script&lang=js&"
import style0 from "./wx-register.vue?vue&type=style&index=0&id=5172950a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5172950a",
  null
  
)

export default component.exports